export default __webpack_public_path__ + "static/media/ic-folder.3cf32bbe.svg";